import { withToken, axiosInstanceV1 } from "@bn/api";
import { jwtDecode } from "jwt-decode";
import * as Sentry from "@sentry/browser";
import { User, UserWithType } from "@api/v1/model";

const ROLE_PLUS_USER_ROLE = "ROLE_PLUS_SUBSCRIPTION";
const ROLE_FINANZFLUSS_PLUS_SUBSCRIPTION = "ROLE_FINANZFLUSS_PLUS_SUBSCRIPTION";
const ROLE_PRO_SUBSCRIPTION = "ROLE_PRO_SUBSCRIPTION";
const ROLE_SM_AG_PLUS_SUBSCRIPTION = "ROLE_SM_AG_PLUS_SUBSCRIPTION";
const ROLE_SM_AG_PLUS_SUBSCRIPTION_EXPIRED =
  "ROLE_SM_AG_PLUS_SUBSCRIPTION_EXPIRED";

export const loadMyself = async (
  token: string | undefined
): Promise<UserWithType> => {
  const response = await axiosInstanceV1.get<User>(`/users/myself`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  let isUserPlus = false;
  let isUserPro = false;
  let isSmartbrokerPlusExpired = false;

  try {
    const parsedToken = token ? jwtDecode<{ roles: string[] }>(token) : null;
    isUserPro =
      parsedToken?.roles?.includes(ROLE_FINANZFLUSS_PLUS_SUBSCRIPTION) ||
      parsedToken?.roles?.includes(ROLE_PRO_SUBSCRIPTION) ||
      false;
    isUserPlus =
      response.data.roles?.includes(ROLE_PLUS_USER_ROLE) ||
      response.data.roles?.includes(ROLE_SM_AG_PLUS_SUBSCRIPTION) ||
      false;
    // The backend never assigns both Smartbroker+ roles at once, but a user can
    // hold plus through ROLE_PLUS_SUBSCRIPTION independently — that one keeps
    // premium unlocked, so an expired Smartbroker+ import is not worth a notice.
    isSmartbrokerPlusExpired =
      (response.data.roles?.includes(ROLE_SM_AG_PLUS_SUBSCRIPTION_EXPIRED) ||
        false) &&
      !isUserPlus;
  } catch (e) {
    // Leaves every flag false, which locks premium and shows no notice — the
    // fail-safe the ticket asks for when the roles cannot be read.
    Sentry.captureException(e);
  }

  const isUserFree = !isUserPro && !isUserPlus;

  return {
    ...response.data,
    isUserPro,
    isUserFree,
    isUserPlus,
    isSmartbrokerPlusExpired,
  };
};

export const getMyself = withToken(loadMyself);
